import { render } from "./icon-email.vue?vue&type=template&id=59cb65f4"
import script from "./icon-email.vue?vue&type=script&lang=js"
export * from "./icon-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__